<template>
  <div>
    <main-header></main-header>
    <race-form1></race-form1>
  </div>
</template>

<script>
import MainHeader from "@/components/index/MainHeader";
import RaceForm1 from '@/components/RaceForm1';
import RaceServices from '@/services/RaceServices';

export default {
  data() {
    return {
      dialog: false,
      CarouselItems: [
        {
          src: "../assets/1-min.jpg"
        },
        {
          src: "../assets/2-min.jpg"
        },
        {
          src: "../assets/3-min.jpg"
        },
        {
          src: "../assets/4-min.jpg"
        }
      ]
    };
  },
  components: {
    MainHeader,
    RaceForm1
  },
};
</script>

<style scoped>
</style>
